import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-merchants",
  "use": "icon-soc-merchants-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-merchants\">\r\n<g transform=\"translate(-176.128 -133.120) scale(1.344000)\">\r\n<path d=\"M192 320h640v480H192V320zm96 96v288h448V416H288z\" />\r\n  <path d=\"M352 160h320v160H352V160zm64 48v64h192v-64H416z\" />\r\n  <path d=\"M384 512h64v96h-64v-96zm192 0h64v96h-64v-96z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-merchants.svg
// module id = Tp81
// module chunks = 409